import React, { useState } from "react";
import { Button, Stack } from "@mui/material";
import Casnic from "./Casnic";
import Casnic2 from "./Casnic2";
import Prosumator from "./Prosumator";
import HomeIcon from "@mui/icons-material/Home";
import PowerIcon from "@mui/icons-material/Power";

const Main = () => {
  const [tipConsumator, setTipConsumator] = useState("casnic");

  const handleButtonClick = (tip) => {
    setTipConsumator(tip);
  };

  return (
    <div>
      {/* <Stack spacing={2}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: tipConsumator === "casnic" ? "#00aeef" : "#29348f",
            width: "250px",
          }}
          onClick={() => handleButtonClick("casnic")}
          startIcon={<HomeIcon />}
        >
          Client Casnic
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor:
              tipConsumator === "prosumator" ? "#00aeef" : "#29348f",
            width: "250px",
          }}
          onClick={() => handleButtonClick("prosumator")}
          startIcon={<PowerIcon />}
        >
          Client Prosumator
        </Button>
      </Stack>
      <div style={{width:'-webkit-fill-available'}}>
        {tipConsumator === "casnic" && <Casnic />}
        {tipConsumator === "prosumator" && <Prosumator />}
      </div> */}
      {/* <Casnic />{" "} */}
      <Casnic2/>
    </div>
  );
};

export default Main;
